import React, { useEffect } from 'react';
import authService from '../services/auth.service';
import { useNavigate } from 'react-router-dom';
import Dashboard from './Dashborad';
import { useRecoilState } from 'recoil';
import { userState } from '../atoms/userAtom';
export const API_URL = '/api/v1/worker';
const Home = () => {
  const [userToken, setUserToken] = useRecoilState(userState);
  let history = useNavigate();
  useEffect(() => {
    const user = authService.getCurrentUser();

    if (user === null) {
      return history('/login');
    }
    setUserToken(JSON.parse(localStorage.getItem('token')));
  }, [history, setUserToken]);

  return (
    <div>
      <Dashboard token={userToken} />
    </div>
  );
};

export default Home;
